require('./brokerRightsCashExchangeStep1.scss');

// @Vendor
const React = require('react');
const PropTypes = require('prop-types');

// @Components
const { formatText, FormattedText } = require('core/i18n').i18n;
const { InputSafe } = require('commonsComponents/inputSafe');   

class BrokerRightsCashExchangeStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleChangeRightsQuantity = this.handleChangeRightsQuantity.bind(this);
    }

    handleChangeRightsQuantity(event) {
        const { onChangeRightsQuantity } = this.props;
        const rightsQuantity = event.target.value;
        onChangeRightsQuantity(rightsQuantity);
    }

    buildAmountInput() {
        const { immStep1 } = this.props;
        const rightsQuantity = immStep1.get('rightsQuantity');
        const rightsQuantityInputError = immStep1.get('rightsQuantityError');
        const errorMessage = formatText('brokerRightsCashExchange-brokerRightsCashExchange_step1ErrorText');
        return (
            <div className="broker-rights-cash-exchange-step1__group-div">
                <h2 className="broker-rights-cash-exchange-step1__subtitle">
                    <FormattedText
                        value="brokerRightsCashExchange-brokerRightsCashExchange_step1AmountText"
                        className="broker-rights-cash-exchange-step1__subtitle-text"
                    />
                </h2>
                <div className="broker-rights-cash-exchange-step1__input-container">
                    <InputSafe
                        type="text"
                        value={rightsQuantity}
                        autoComplete="off"
                        onChange={this.handleChangeRightsQuantity}
                        errorState={rightsQuantityInputError}
                        errorMessage={errorMessage}
                    />
                </div>
            </div>
        );
    }

    buildHeader() {
        return (
            <header className="broker-rights-cash-exchange-step1__header">
                <h2 className="broker-rights-cash-exchange-step1__header-title">
                    <FormattedText value="brokerRightsCashExchange-brokerRightsCashExchange_step1HeaderTitle" />
                </h2>
                <h4 className="bbroker-rights-cash-exchange-step1__header-subtitle">
                    <FormattedText value="brokerRightsCashExchange-brokerRightsCashExchange_step1HeaderSubtitle" />
                </h4>
            </header>
        );
    }
    
    render() {
        return (
            <div className="broker-rights-cash-exchange-step1">
                {this.buildHeader()}
                {this.buildAmountInput()}
            </div>
        );
    }
}

BrokerRightsCashExchangeStep1.propTypes = {
    onChangeRightsQuantity: PropTypes.func.isRequired,
    immStep1: PropTypes.object.isRequired
}

module.exports = BrokerRightsCashExchangeStep1;
